/* unplugin-vue-components disabled */
import $profile from 'stores/profile'

export default {
  emits: ['submit'],
  data() {
    return {
      u_store: undefined,
      validity: {
        first_name: true,
        last_name: true
      }
    }
  },
  computed: {
    valid() {
      return Object.values(this.validity).every(x => x)
    },
    can_submit() {
      return this.u_store.changed && this.valid
    },
    saving() {
      return this.u_store.saving
    }
  },
  methods: {
    open(u_store) {
      this.u_store = u_store.clone()
      this.$refs.modal.open()
      this.$nextTick(() => this.$refs.firstName.focus())
    },
    close() {
      if (!this.saving) this.$refs.modal.close()
    },
    async submit() {
      await this.u_store.save()
      this.$emit('submit', this.u_store)
      if (this.u_store.id === $profile.id) {
        return window.location.reload()
      }
      $utils.toasts.success(`User <b>${this.u_store.display_name}</b> successfully updated.`)
      this.close()
    }
  }
}
